import { defineComponent, getCurrentInstance } from 'vue';
import { provideSidebarLayout } from '@integro/ui';

export const AppLayoutSidebar = defineComponent({
  name: 'AppLayoutSidebar',
  setup() {
    const api = provideSidebarLayout();
    const instance = getCurrentInstance();
    const $app = instance?.appContext.config.globalProperties.$app as
      | Record<string, unknown>
      | undefined;
    if ($app) {
      $app.sidebar = {
        get collapsed() {
          return api.collapsed.value;
        },
        get width() {
          return api.width.value;
        },
        get collapsedRailWidth() {
          return api.collapsedRailWidth.value;
        },
        toggle: api.toggle,
        setCollapsed: api.setCollapsed,
        setWidth: api.setWidth,
      };
    }
  },
  template: `
    <div class="app-shell">
      <div class="app d-flex flex-column flex-nowrap h-100 overflow-hidden">
        <AppNavbar
          class="app__navbar flex-shrink-0"
          style="z-index: 1030; position: relative"
        />
        <div
          class="app__content flex-grow-1 bg-light position-relative overflow-hidden"
        >
          <ItpSidebar
            variant="app"
            :scroll-y="true"
            content-class=""
            :show-toggle="false"
          >
            <ItpRouterTabSidebar
              home-route="/"
              home-title="Dashboard"
              home-icon="fa fa-home"
            />
          </ItpSidebar>
          <div
            class="app__content-main h-100 overflow-hidden"
            :style="{
              marginLeft: 'var(--itp-sidebar-w, 0px)',
              transition: 'margin-left var(--itp-sidebar-transition, 0.15s ease)',
            }"
          >
            <ItpRouterTabContent />
          </div>
        </div>
        <ItpModalHost />
      </div>
    </div>
  `,
});

export default AppLayoutSidebar;
